import cx from 'classnames';
import WowIcon from '../../scripts/wow/components/WowIcon';

export type TUserAvatarIconProps = {
  icon: string;
  size: 'xx-small' | 'x-small' | 'small' | 'medium' | 'large';
  className?: string;
  style?: any;
};

const DEFAULT_ICON_STYLES: any = {
  'xx-small': {
    fontSize: 18
  },
  'x-small': {
    fontSize: 20
  },
  small: {
    fontSize: 26
  },
  medium: {
    fontSize: 36
  },
  large: {
    fontSize: 56
  }
};

export function UserAvatarIcon(props: TUserAvatarIconProps) {
  if (!props.icon) {
    return (
      <span className={cx('slds-avatar', props.className)} style={props.style}>
        <i className="fas fa-user-circle" style={DEFAULT_ICON_STYLES[props.size]} />
      </span>
    );
  }

  return (
    <WowIcon
      icon={props.icon}
      size={props.size}
      className={cx(`slds-avatar slds-avatar--circle slds-avatar--${props.size} rio-avatar--border`, props.className)}
      imgStyle={{ transform: 'scale(1.16)' }}
      style={props.style}
    />
  );
}
